// extracted by css-extract-rspack-plugin
export default {"nudgeCard":"ZOGYo","description":"uXj7g","subtitle":"zAhFj","proLink":"OOISB"};